/** Per-user count of increased-cadence Dictate feedback prompts already shown. */
export const DICTATION_FEEDBACK_INCREASED_CADENCE_PROMPT_COUNT_STORAGE_KEY =
  'heidi:dictation-csat-increased-cadence-prompt-count';
